import { PlayerService } from "./PlayerService";

export class InventoryService {
    private _playerService: PlayerService = new PlayerService();

    public async getInventory(): Promise<Response> {
        const response: Response = await fetch(
            `${VITE_API_URL}ac/inventory`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }
        );
        return response;
    }
}
